import React, {ReactNode} from 'react';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {OverlayTriggerRenderProps} from "react-bootstrap/OverlayTrigger";

interface MyTooltipProps {
  title: string;
  position: 'top' | 'right' | 'bottom' | 'left';
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>> | ((props: OverlayTriggerRenderProps) => ReactNode)
}

export const MyTooltip: React.FC<MyTooltipProps> = ({title, position, children}) => {
  const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        {title}
      </Tooltip>
  );

  return (
      <OverlayTrigger placement={position} overlay={renderTooltip}>
        {children}
      </OverlayTrigger>
  );
};

